// MyWalletTemp.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
// import MainLayout from '../../layouts/MainLayout';
import './MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';

const MyWalletTemp = () => {
  const authState = useSelector(state => state.authReducer);
  const userId = authState.user._id;
  const userCode = authState.user.think5whyscode;
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [walletData, setWalletData] = useState([]);
  const [selectedWalletId, setSelectedWalletId] = useState([]);
  const [payerName, setPayerName] = useState(authState.user.name);
  const [payeeId, setPayeeId] = useState('');
  const [payeeName, setPayeeName] = useState(authState.user.name);
  const [amount, setAmount] =  useState(0);
  const [paymentClicked, setPaymentClicked] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);

  //Wallet Transactions
  const fetchWalletTemp = useCallback(() => {
    const config = {
      url: "/wallettemp",
      method: "get",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Response:", response);
        if (response && Array.isArray(response)) {
          setWalletData(response);
        } else {
          console.error("Invalid response format: Wallet temp data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching wallet temp:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletTemp();
  }, [authState.isLoggedIn, fetchWalletTemp]);

  const sortedWalletData = [...walletData].sort((a, b) => new Date(b.dateTransaction) - new Date(a.dateTransaction));

  const handleWalletView = (_id) => {
    setSelectedWalletId(prevId => (prevId === _id ? null : _id));
  };

  const handleWalletTempClick = (userId) => {
    navigate('/wallet-paytemp', { state: { userId: userId } });
  };

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleCancel = () => {
    navigate(-1);
  };

const handleAddPayeeButtonClick = (amt, remarks, id) => {
  setPaymentClicked(true);
  saveWalletTransaction(amt, remarks, id);
};

const saveWalletTransaction = async (amt, remarks, id) => {
  const requestData = {
    walletTempId: id,
    payeeName: payeeName,
    payerId: userId,
    payeeId: userId,
    dateTransaction: new Date(),
    particulars: "Transfer from Other Payemnt to Wallet",
    amount: amt,
    currency: "Credits",
    inOut: 1,  //Transfer (In)
    points: 0,
    wallet: "User Wallet",
    remarks: remarks,
    modePayment: "Transfer into Think5Whys Wallet",
    transactionId: 'D' + Date.now(),
    transactionDate: Date.now(),
    transactionStatus: 'Success',
    paymentDetails: 'NA',
    isActive: 1,
    isDeleted: 0,
    dateCreated: new Date(),
    createdBy: userId,
    isApproved: true,
    transferredBy: userId,
    dateTransferred: Date.now(),
  };
  // console.log('Wallet Transfer from Wallet Temp to be saved:', requestData);
  try {
    const config = { 
      url: `/wallet/temptowallet`, 
      method: "post", 
      data: requestData, 
      headers: { Authorization: authState.token } 
    };
    await fetchData(config);
    setPaymentStatus(true)
    // console.log("After Saving Data", fetchData)
    navigate('/wallet-mywallet');
  } catch (error) {
    console.error('An error occurred while fetching data:', error);
  }
};

  return (
      <div className='space-y-3 bg-gray-800 text-white [&_p]:text-gray-100'>
        {/* <h3 className='text-sm lg:text-lg  border-b border-b-gray-300 text-white'>My Other Payments</h3> */}
          {loading ? (
            <Loader />
          ) : (
            <div className='w-full'>
              <div className="flex flex-row justify-between items-center ">
                <h3 className='text-sm lg:text-lgmt-1 mx-2 text-white'><FontAwesomeIcon icon={faWallet} className="text-xs lg:text-sm text-red-500 mr-2" />Paid By Other Methods</h3>
                <div className='flex flex-row'>
                  <button
                    className='text-xs lg:text-sm bg-blue-700 w-fit py-1 px-2'
                    onClick={() => handleWalletTempClick(userId)}
                  >
                    Pay by Other Mode
                  </button>
                  <button
                    className='text-xs lg:text-sm bg-blue-700 w-fit py-1 px-2'
                    onClick={handleCancel}
                  >
                    Back
                  </button>
                </div>
              </div>
              <div>
                {walletData && walletData.length === 0 ? (
                  <div className="text-xs lg:text-sm flex items-center justify-center text-yellow-300 h-64">
                    No records found!
                  </div>
                ) : (
                  <>
                    {sortedWalletData.map((walletItem, index) => (
                      <div
                        key={walletItem._id}
                        className={`
                          ${walletItem.isApproved
                            ? walletItem.transferredBy !== null
                              ? "bg-gray-900 border border-gray-700"
                              : "bg-gray-800 border border-gray-700"
                            : "bg-gray-700 border border-gray-600"}
                          my-4 p-4 rounded-2xl shadow-lg text-white text-xs lg:text-sm
                          transition-all duration-200
                        `}
                      >
                        {/* HEADER ROW */}
                        <div className="flex justify-between items-start gap-3 mb-3">

                          <div className="text-xs lg:text-sm font-medium leading-snug">
                            <span className="text-gray-300">
                              {index + 1}.
                            </span>{" "}

                            <span className="text-white">
                              {formatDateTime(walletItem.dateTransaction)}
                            </span>{" "}

                            <span className="text-gray-200">
                              {walletItem.currency}
                            </span>{" "}

                            <span className="text-green-300 font-semibold">
                              {Number(walletItem?.amount?.$numberDecimal ?? walletItem?.amount ?? 0).toFixed(2)}
                            </span>

                            <div className="mt-2 flex flex-wrap gap-2 text-[10px] lg:text-xs">

                              <span className="px-2 py-1 rounded-full bg-yellow-500/10 text-yellow-300 border border-yellow-500/20">
                                {walletItem.isApproved === false
                                  ? "⏳ Waiting Approval"
                                  : "✅ Approved"}
                              </span>

                              <span className="px-2 py-1 rounded-full bg-blue-500/10 text-blue-300 border border-blue-500/20">
                                {walletItem.transferredBy === null
                                  ? "💰 Balance Updated"
                                  : "🔄 Balance Moved"}
                              </span>

                            </div>
                          </div>

                          {/* VIEW ICON */}
                          <Tooltip text="View details" position="top">
                            <span
                              className="text-white cursor-pointer text-lg hover:text-cyan-400 transition"
                              onClick={() => handleWalletView(walletItem._id)}
                            >
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                        </div>

                        {/* EXPANDED DETAILS */}
                        {selectedWalletId === walletItem._id && (
                          <>
                            <div className="bg-gray-900 border border-gray-700 rounded-xl p-4 text-gray-200 text-xs [&_p]:text-xs space-y-2">
                              <p><strong>Date:</strong> {formatDateTime(walletItem.dateTransaction)}</p>
                              <p><strong>Particulars:</strong> {walletItem.particulars}</p>
                              <p><strong>Credits:</strong> {walletItem.currency} {Number(walletItem?.amount?.$numberDecimal ?? walletItem?.amount ?? 0).toFixed(2)}</p>
                              <p><strong>Remarks:</strong> {walletItem.remarks}</p>
                              <p><strong>Mode:</strong> {walletItem.modePayment}</p>
                              <p><strong>Payment Details:</strong> {walletItem.paymentDetails}</p>
                            </div>

                            {/* ACTION SECTION */}
                            {walletItem.isApproved === true && walletItem.transferredBy === null && (
                              <div className="mt-4 p-4 bg-black border border-gray-700 rounded-xl">

                                <div className="flex flex-col md:flex-row gap-2">

                                  <button
                                    onClick={() =>
                                      handleAddPayeeButtonClick(
                                        walletItem.amount,
                                        walletItem.remarks,
                                        walletItem._id
                                      )
                                    }
                                    disabled={paymentClicked}
                                    className="flex-1 bg-orange-500 hover:bg-orange-600 text-white text-xs lg:text-sm px-4 py-2 rounded-lg transition"
                                  >
                                    Confirm Transfer Credits {Number(walletItem?.amount?.$numberDecimal ?? walletItem?.amount ?? 0).toFixed(2)}
                                  </button>

                                  <button
                                    onClick={handleCancel}
                                    className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-xs lg:text-sm px-4 py-2 rounded-lg transition"
                                  >
                                    Cancel
                                  </button>

                                </div>

                                {/* STATUS */}
                                {paymentClicked && (
                                  <div className="text-center mt-3 text-xs lg:text-sm">
                                    {paymentStatus ? (
                                      <p className="text-green-400">
                                        ✔ Transferred Credits {Number(walletItem?.amount?.$numberDecimal ?? walletItem?.amount ?? 0).toFixed(2)} to {payeeName}
                                      </p>
                                    ) : (
                                      <p className="text-red-400">
                                        ✖ Transfer of Credits {Number(walletItem?.amount?.$numberDecimal ?? walletItem?.amount ?? 0).toFixed(2)} to {payeeName} failed. Retry.
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
      </div>
  );
};

export default MyWalletTemp;




